export enum IpafStatus {
	IN_PROGRESS = 'IPAF_IN_PROGRESS',
	PROGRESS = 'IN_PROGRESS',
	EXPIRED = 'EXPIRED',
	IPAF_EXPIRED = 'IPAF_EXPIRED',
	QUOTING = 'QUOTING',
	QUOTE_READY = 'QUOTE_READY',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED',
	APPROVED = 'APPROVED',
	CLOSED = 'CLOSED',
	CURRENT_POLICY = 'CURRENT_POLICY',
	CURRENT_QUOTING = 'CURRENT_QUOTING',
	BEING_QUOTED = 'BEING_QUOTED',
	CURRENT_POLICY_ANOTHER_BROKER = 'CURRENT_POLICY_ANOTHER_BROKER',
	EMPTY = 'EMPTY',
	INITIAL = 'INITIAL',
}
